export const ADD_FIXED_EXPENSE = 'ADD_FIXED_EXPENSE';
export const SHOW_FIXED_EXPENSE = 'SHOW_FIXED_EXPENSE';
export const ADD_EXPENSE_VARIABLE = 'ADD_EXPENSE_VARIABLE';
export const SHOW_EXPENSE_VARIABLE = 'SHOW_EXPENSE_VARIABLE';
